import axios from "@/lib/axios";
import { User } from "@/types/user";

type GetCurrentUserResponse = User;

export const getCurrentUser = () =>
  axios.get<GetCurrentUserResponse>(`/v1/users/me`).then((res) => res.data);
